import type { FaireProductEntity } from "../../entity_types/product";

export const p_z8n9hb824h: FaireProductEntity = {
  token: "p_z8n9hb824h",
  type: "product",
  name: "Barbican Cocktail Jigger",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl: "https://cdn.faire.com/fastly/bf6b356c68ee3e92736478fe3df27d503f143dda7f66a561ebbcef709ddd4656.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd949bc0c9708fa66008a3b64d1d1333e5bcacecdd11711191d31e680ba7cc82.jpeg",
    "https://cdn.faire.com/fastly/c59b1ec3e3cd46b217429e819226cb0e27dca8e576a60ca54eed04ea873aa15d.jpeg",
    "https://cdn.faire.com/fastly/14e436e5291bd9fad12f704958713c1ac2117e4bb2631c4a56aac69409e1577a.jpeg",
    "https://cdn.faire.com/fastly/89bc6774685ec1441e118bc38522ae26c35384daf822fbfcfc56f5eb75941381.jpeg"
  ],
  priceDollars: 17,
  description: "BARBICAN is a barware collection inspired by the bold lines and functionality of brutalist\narchitecture.\n\nThe BARBICAN Jigger reflects this spirit in a well-proportioned, functional form. Double-sided, with clearly marked ounce and millilitre measurements, it is designed to accommodate any cocktail recipe. Skillfully crafted from high-grade stainless steel.\n\nMaterial: 18/8 stainless steel\nSize: Ø5.8 x 9.5 cm / Ø2.3” x 3.7”\nCapacity: 50ml / 2 fl oz\n\nDishwasher-safe, handwash recommended.",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:30.004Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
